import {
  FormControl,
  FormHelperText,
  Icon,
  Input,
  InputLabel,
} from "@mui/material";
import React, { useState } from "react";
import CoreIconButton from "./CoreIconButton";
import CoreTypographyCaption from "../dataDisplay/CoreTypographyCaption";
import CoreFormHelperText from "../dataDisplay/CoreFormHelperText";

export default function CorePassword(props) {
  const [hidden, setHidden] = useState(true);

  const { id, formikProps } = props;

  return (
    <FormControl fullWidth={true}>
      <InputLabel style={{ marginLeft: -10 }}>{props.label}</InputLabel>
      <Input
        type={hidden ? "password" : "text"}
        {...props}
        endAdornment={
          <CoreIconButton
            tabIndex={-1}
            onClick={() => {
              setHidden(!hidden);
            }}
          >
            <Icon>{hidden ? "visibility" : "visibility_off"}</Icon>
          </CoreIconButton>
        }
        autoComplete="off"
        inputProps={{ "aria-autocomplete": "none" }}
      />
      <CoreFormHelperText error>
        {formikProps?.touched[id] && formikProps?.errors[id]}
      </CoreFormHelperText>
    </FormControl>
  );
}
